import './DateInput.scss';

const DateInput = ({mode = 'date', value, onChange, className = '', ...rest}) => (
    <input
        id={`date-input-${mode}`}
        type={mode}
        className={`date-input ${className}`}
        value={value ?? ''}
        onChange={e => onChange(e.target.value || null)}
        {...rest}
    />
);

export default DateInput;
